export default class CardGame {
	static STATE_INITIAL = 1; //свое значение
	static STATE_START_PLAY = 2; //свое значение
	static STATE_SELECT_CARD = 3; //свое значение
	static STATE_PLAY_4_OF_5_SELECT_CARDS = 4; //свое значение
	static STATE_PLAY_4_OF_5_GAIN_CARDS = 5; //свое значение
	static STATE_YOUR_WON_CARD = 6; //свое значение
	static STATE_DISCARDED_CARDS = 7; //свое значение
	static STATE_DISCARDED_CARDS_REMOVE = 8; //свое значение
}